import styled from 'styled-components'
import { media } from '../../utils'

export const LeftRightContainer = styled.div`
  padding: 15px;
  ${media.giant`
    display: flex;
    align-items: flex-start;
    justify-content: space-around;
    padding: 30px 15px;
  `}
  ${media.largePhone`
    display: unset;
  `}
`

export const LeftRightItem = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: flex-end;
  text-align: right;

  &:nth-child(odd) {
    align-items: flex-start;
    text-align: left;
  }
`



// WEBPACK FOOTER //
// ./src/components/containers/LeftRight.tsx